export enum LiveState
/**
 * 尚未初始化
 */ {
  NOTINITIALIZED = -1,

  /**
   * 正在链接中
   */
  CONNECTING = 0,

  /**
   * 已经链接并且可以通讯
   */
  OPEN = 1,

  /**
   * 连接已关闭或者链接失败
   */
  CLOSED = 3,
}
